module.exports = __webpack_public_path__ + "img/oufu_25x45x10.prt.09b3d0e4.jpg";